// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1nLGO","actionsCol":"EnrolledClinics_actionsCol__2JEGy"};